import { AuditMatch, DateTimeStr, Station, TimeRange } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api';
import { isAuditEnabled } from '../helpers';

export function useAuditSpotMatches(
  station: Station,
  range: TimeRange<DateTimeStr>,
  options?: {
    size?: number;
    customId?: string | null;
  },
) {
  const params = {
    stationId: station.id,
    pageSize: options?.size ?? 250,
    filter: {
      from: range.from,
      to: range.to,
      ...(options?.customId && { customId: options.customId }),
    },
  };

  return useQuery({
    queryKey: ['audit-spot-matches', params],
    queryFn: async (): Promise<AuditMatch[]> => {
      if (!isAuditEnabled(station)) {
        return [];
      }

      const { results } = await apiClient.audit.fetchMatches(params);

      return results;
    },
    enabled: options?.customId === undefined || !!options.customId,
  });
}
